

const initialState = {
  isLoading: false,
  service: {},
  newService: {},
   currentData:{},
  // details: {},
  errors: null,
};

const ServiceReducers = (state = initialState, action) => {
  switch (action.type) {
    case "serviceList_req":
      return {
        ...state,
        isLoading: true,
      };
    case "serviceList_success":
      return {
        ...state,
        isLoading: false,

        service: action.payload,
      };
    case "serviceList_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "serviceList_req_delete":
      return {
        ...state,
        isLoading: true,
      };
    case "serviceList_delete_success":
      return {
        ...state,
        isLoading: false,

        service: action.payload,
      };
    case "serviceList_delete_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "add_service_req":
      return {
        ...state,
        isLoading: true,
      };
    case "add_service_success":
      return {
        ...state,
        isLoading: false,

        newService: action.payload,
      };
    case "add_service_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "edit_service_req":
      return {
        ...state,
        isLoading: true,
      };
    case "edit_service_success":
      return {
        ...state,
        isLoading: false,

        newService: action.payload,
      };

    case "edit_service_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "set_service_details":
      return {
        ...state,
        laoding: false,
        currentData: action.payload,
      };
    // case "reset_facility_details":
    //   return {
    //     ...state,
    //     laoding: false,
    //     currentData: {},
    //   };

    default:
      return state;
  }
};

export { ServiceReducers };
